export default __webpack_public_path__ + "static/media/error-icon.7204b460.svg";